<div class="tw:p-4" data-test="history-drawer">
  <div class="tw:flex tw:items-center tw:mb-4">
    <h2 class="tw:text-lg tw:font-bold tw:flex-1">History: {{data.item.displayName}}</h2>
    <button type="button" class="btn" (click)="close()" data-test="history-close">Close</button>
  </div>

  @if (loading) {
    <p>Loading…</p>
  }

  @if (error) {
    <div class="tw:p-3 tw:border tw:border-red-500 tw:bg-red-50 tw:text-red-900 tw:rounded" data-test="history-error">{{error}}</div>
  }

  @if (!loading && !error) {
    @for (row of rows; track row.featureSwitchHistoryId) {
      <div class="tw:py-2 tw:border-b tw:border-gray-200" data-test="history-row">
        <div class="tw:text-sm">
          <strong><admin-email [value]="row.changedBy || 'unknown'" /></strong>
          <span class="tw:opacity-75"> · {{row.changedUtc | date:'dd/MM/yyyy HH:mm'}}</span>
        </div>
        <div class="tw:text-sm"><span class="tw:opacity-60">Before:</span> {{describe(row.before)}}</div>
        <div class="tw:text-sm"><span class="tw:opacity-60">After:</span> {{describe(row.after)}}</div>
      </div>
    } @empty {
      <p class="tw:opacity-60" data-test="history-empty">No changes recorded yet.</p>
    }
  }
</div>
